<template lang="pug">
  span(:drawCount="drawCount")
    RowItemTemplate(v-for="(child, child_id) in items" :key="child_id")
      template(slot="label")
        span {{child.label}}
        br
        span {{child.comment}}
      template(slot="value")
        .radio
          .price
            span.main {{comma(child.price)}}万円
            span.tax (内 納税額{{comma(child.tax)}}万円)
          v-checkbox.check(label="既に他界" v-model="child.exist" @change="data_change")
      template(slot="row")
        RowItemTemplate(v-for="(grand_child, grand_child_id) in child[child_key]" :key="grand_child_id" :is_child="true")
          template(slot="label")
            span {{grand_child.label}}
            br
            span {{grand_child.comment}}
          template(slot="value")
            .radio
              .price
                span.main {{comma(grand_child.price)}}万円
                span.tax (内 納税額{{comma(grand_child.tax)}}万円)
              v-checkbox.check(label="既に他界" v-model="grand_child.exist" @change="data_change")
</template>

<script lang="js">
import step03Module from '@/module/step03Module';
import RowItemTemplate from '@/components/step03/RowItemTemplate.vue';

export default {
  components: {
    RowItemTemplate,
  },
  props: {
    items: {
      type: Array,
      default: [],
    },
    child_key: {
      type: String,
      default: '',
    },
    drawCount: {
      type: Number,
      default: 0,
    },
  },
  methods: {
    comma(num) {
      return step03Module.comma(num);
    },
    data_change() {
      this.$emit('data_change');
    },
  },
};
</script>

<style lang="sass" scoped>
</style>